import React, { Component } from 'react';
import { connect } from 'react-redux';
import PriceChangesView from './PriceChanges.view';

export class PriceChangesContainer extends Component {

  constructor(props){
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
  }

  componentDidMount() {
    this.getPriceChanges(this.props);
  }

  componentWillReceiveProps(nextProps){
    if(
      this.props.filtersFormState !== nextProps.filtersFormState ||
      this.props.page !== nextProps.page
    ){
      this.getPriceChanges(nextProps);
    }
  }

  getPriceChanges(props){
    const { dispatch, filtersFormState, page } = props;
    dispatch({
      type: 'FETCH_PRICE_CHANGES',
      payload: {
        filters: filtersFormState.data,
        page: page,
      }
    });
  }

  nextPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'PRICE_CHANGES_NEXT_PAGE',
    });
  }

  previousPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'PRICE_CHANGES_PREVIOUS_PAGE',
    });
  }

  onFilterChange(filtersFormState){
    const { dispatch } = this.props;
    dispatch({
      type: 'PRICE_CHANGES_FILTERS_CHANGE',
      payload: {
        filtersFormState,
      }
    });
  }

  render() {
    return (<PriceChangesView
      onFilterChange={this.onFilterChange}
      nextPage={this.nextPage}
      previousPage={this.previousPage}
      {...this.props}
    />);
  }

}

function mapStateToProps(state) {
  const { priceChanges } = state;
  return {
    priceChanges: priceChanges.priceChanges,
    filtersFormState: priceChanges.filtersFormState,
    page: priceChanges.page,
  };
}

export default connect(mapStateToProps)(PriceChangesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/PriceChanges/PriceChanges.container.js